import { YOUTUBE_OEMBED_URL } from "./constants";
const getYouTubeOEmbedUrl = (videoId) =>
  `${YOUTUBE_OEMBED_URL}?url=${encodeURIComponent(
    `https://www.youtube.com/watch?v=${videoId}`,
  )}&format=json`;

export const fetchYouTubeVideoTitles = async (videoIds, signal) => {
  const titleEntries = await Promise.all(
    videoIds.map(async (videoId) => {
      try {
        const response = await fetch(getYouTubeOEmbedUrl(videoId), { signal });

        if (!response.ok) {
          return [videoId, null];
        }

        const data = await response.json();
        const title = typeof data.title === "string" ? data.title.trim() : "";

        return [videoId, title || null];
      } catch (error) {
        if (error.name === "AbortError") {
          throw error;
        }

        return [videoId, null];
      }
    }),
  );

  return Object.fromEntries(titleEntries);
};
